import { updateRoomPreference, updateRoomPreferenceFulfilled } from 'store/profile/profile.slice';
import { prepareGuestPreferenceListWithRoomPreference } from '../profile.helpers';
import { updateProfileTemplate } from './updateProfile';

export default updateProfileTemplate({
	actionType: updateRoomPreference.type,
	fulfillAction: updateRoomPreferenceFulfilled,
	updateFn: ({ extension = {} } = {}, newValue) => ({
		extension: {
			...extension,
			guestPreferenceList: prepareGuestPreferenceListWithRoomPreference(
				extension.guestPreferenceList,
				newValue
			),
		},
	}),
});
